<template>
  <base-section
    id="arbetsgivare-section"
    v-on:retry="props.onRetry"
    heading="Arbetsgivare"
    :info-status="arbetsgivare.infoStatus"
    :show-error="arbetsgivare.error"
  >
    <avtalat-spinner v-if="arbetsgivare.isLoading" />
    <HelpText v-else :text="helpTexts.arbetsgivare.arbetsgivare" />
    <div
      id="arbetsgivare-content"
      class="arbetsgivare-content"
      v-for="arbetsgivaren in arbetsgivare.data?.slice(0, visibleArbetsgivare)"
      :key="arbetsgivaren.arbetsgivareId"
    >
      <section-row
        :title="arbetsgivaren.arbetsgivareTitle"
        :subTitle="formatArbetsgivareSubTitle(arbetsgivaren)"
        :value="arbetsgivaren.datumintervall"
        :subValue="arbetsgivaren.pensionsplan"
      />
    </div>
    <avtalat-button
      v-if="
        arbetsgivare.data && visibleArbetsgivare < arbetsgivare.data?.length
      "
      v-on:click="showMorePreviousArbetsgivare()"
      style="color: teal; border-color: teal"
      small
      outlined
      color="blue"
      >Visa fler</avtalat-button
    >
  </base-section>
</template>

<script lang="ts" setup>
import { computed, ref } from "vue";

import { BaseSection, SectionRow } from "@/components/sections";
import HelpText from "@/components/ui/HelpText.vue";
import type { IArbetsgivare } from "@/composables/KundserviceAppApiClient";
import helpTexts from "@/config/helpTexts";

import { useAnstalldStore } from "../store";

type ArbetsgivareSectionProps = {
  onRetry?: () => void;
};

const props = defineProps<ArbetsgivareSectionProps>();

const visibleArbetsgivareStartValue = 2;
const numberOfPreviousArbetsgivareToDisplay = 3;
const visibleArbetsgivare = ref(visibleArbetsgivareStartValue);
const anstalldaStore = useAnstalldStore();
const arbetsgivare = computed(() => anstalldaStore.arbetsgivare);
const showMorePreviousArbetsgivare = () => {
  visibleArbetsgivare.value += numberOfPreviousArbetsgivareToDisplay;
};

const formatArbetsgivareSubTitle = (arbetsgivare: IArbetsgivare) =>
  arbetsgivare.organisationsnummer +
  (arbetsgivare.isPremiebefriad ? " (Premiebefriad)" : "");
</script>

<style lang="css">
.arbetsgivare-content + button {
  margin-top: 1em;
}
</style>
